import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router"
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSmartModalService } from 'ngx-smart-modal';
@Component({
  selector: 'app-edit-account',
  templateUrl: './edit-account.component.html',
  styleUrls: ['./edit-account.component.scss']
})
export class EditAccountComponent implements OnInit {

  constructor(public ngxSmartModalService: NgxSmartModalService, private spinner: NgxSpinnerService, public http: HttpClient, private router: Router) {this.ping(), this.operator(), this.currencyChoice()}
  profileData: any = [];
  currency:string = '';
  currencyType: any;
  loaded:boolean = false;
  operatorType: any;
  name:string = '';
  email:string = '';
  timezone:string = '';
  mobOperator:string = '';
  
  public ping() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/endpoint/getCurrentProfile',{
      headers:myheader
    })
    .subscribe(
      data => {
         this.profileData = data;
         this.currency = this.profileData.currency.id;
         this.timezone = this.profileData.timezone.displayName;
         this.mobOperator = this.profileData.mobileOperator.id;
         this.name = this.profileData.name;
         this.email = this.profileData.email;
         setTimeout(() => {
          /** spinner ends after 5 seconds */
          this.loaded = true;
        }, 1500);
      },
      error => {
        if (error.status >= 400 && error.status < 500) { 
          this.ngxSmartModalService.create('myModal1', '').open();
        }
        else if (error.status >= 500) { 
location.reload();
        }
        console.log('ERROR:');
        console.log(error);
      }
  );
  }
  public currencyChoice() {
    this.http.get('https://api-staging.videyo.tv/manage/listCurrencies',{
    })
    .subscribe(
      data => {
         this.currencyType = data['currency'];
      },
      error => {
        if (error.status >= 400 && error.status < 500) { 
          this.ngxSmartModalService.create('myModal1', '').open();
        }
        else if (error.status >= 500) { 
location.reload();
        }
        console.log('ERROR:');
        console.log(error);
      }
  );
  }
  
  public changeAccountInfo() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
     this.http.get('https://api-staging.videyo.tv/endpoint/saveProfileUpdate?name='+encodeURIComponent(this.name.trim())+'&email='+encodeURIComponent(this.email)+'&timezone='+encodeURIComponent(this.timezone)+'&currencyID='+this.currency+'&mobileOperatorID='+this.mobOperator,{
      headers:myheader
    })
    .subscribe(
      data => {
        this.router.navigate(['/account']);
      },
      error => {
        if (error.status >= 400 && error.status < 500) { 
          this.ngxSmartModalService.create('myModal1', '').open();
        }
        else if (error.status >= 500) { 
location.reload();
        }
        console.log('ERROR:');
        console.log(error);
      }
  );
  }
  public operator() {
    this.http.get('https://api-staging.videyo.tv/manage/listMobileOperators',{
    })
    .subscribe(
      data => {
         this.operatorType = data['mobileOperator'];
      },
      error => {
        if (error.status >= 400 && error.status < 500) { 
          this.ngxSmartModalService.create('myModal1', '').open();
        }
        else if (error.status >= 500) { 
location.reload();
        }
        console.log('ERROR:');
        console.log(error);
      }
  );
  }
  refresh(): void {
    window.location.reload();
}
  onNameKeyUp(event:any){
    this.name = event.target.value;
  }
  onCurrencyChoice(event:any){
    this.currency = event.target.value;
  }
  updateTimezone(event:any){
    this.timezone = event.target.value;
    
  }
  updateOperator (event:any) { 
    this.mobOperator = event.target.value;
  }
  onEmailKeyUp(event:any){
    this.email = event.target.value;
  }

  ngOnInit() {
    /** spinner starts on init */
    this.spinner.show();
  
  }
  ngAfterViewInit() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
  }, 1500);
  }

}
